import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import messageResource from '../../messageResource'
import {PasswordPolicyLengthRange} from '../../constants'
import {getConfigurablePasswordRules, getCurrentPassword, getNewPassword, getRawSettings} from './selectors'
import rpcCall from '../../util/rpc/rpcCalls'
import {Exceptions} from './constants'
import {createActionObject} from '../../redux/utils'
import {PasswordValidators} from '../../util/passwords/PasswordSettings'


const setMinLength = createAction(ActionTypes.PASSWORD_MIN_LENGTH_SET);
const setMinLengthError = createAction(ActionTypes.PASSWORD_MIN_LENGTH_ERROR_SET);
export const setStrongerFlag = createAction(ActionTypes.PASSWORD_STRONGER_FLAG_SET)

export const startReset = () => (dispatch) => {
    dispatch(createActionObject(ActionTypes.RESET_STARTED))
    dispatch(savePasswordsPolicy())
}

export const completeReset = createAction(ActionTypes.RESET_COMPLETED)
export const failReset = createAction(ActionTypes.RESET_FAILED)
export const resetNotCompletedFor = createAction(ActionTypes.RESET_RESULT_SET_PASSWORD_NOT_RESET_FOR)

export const setCurrentPassword = createAction(ActionTypes.CURRENT_PASSWORD_SET)
export const setNewPassword = createAction(ActionTypes.NEW_PASSWORD_SET)
export const clearPasswords = createAction(ActionTypes.PASSWORDS_CLEAR)
export const setCurrentPasswordInvalid = createAction(ActionTypes.CURRENT_PASSWORD_INVALID_SET)
export const setNewPasswordInvalid = createAction(ActionTypes.NEW_PASSWORD_INVALID_SET)
export const setUserPasswordMatchesPolicy = createAction(ActionTypes.USER_PASSWORD_MATCHES_PASSWORD_POLICY_SET)
export const setPasswordValidationResult = createAction(ActionTypes.PASSWORD_VALIDATION_RESULT_SET)

export const setPasswordMinimalLength = function changeMinLength(newValue) {
    return (dispatch, getState) => {
        newValue = parseInt(newValue)
        if (!newValue || newValue < PasswordPolicyLengthRange.MIN_PASSWORD_LENGTH || newValue > PasswordPolicyLengthRange.MAX_PASSWORD_LENGTH) {
            dispatch(setMinLengthError(messageResource.getMessage(
                'password_settings.minimum_password_length.short',
                [PasswordPolicyLengthRange.MIN_PASSWORD_LENGTH, PasswordPolicyLengthRange.MAX_PASSWORD_LENGTH]
            )))
        } else {
            dispatch(setMinLength(newValue));
        }
    }
}

export const setPasswordRequirement = createAction(ActionTypes.PASSWORD_REQUIREMENT_SET, (id, value) => ({id, value}))

export const setAllPasswordRequirements = function(value) {
    return (dispatch, getState) => {
        for (let id of getConfigurablePasswordRules(getState())) {
            dispatch(setPasswordRequirement(id, value));
        }
    }
}

export const savePasswordsPolicy = () => (dispatch, getState) => {
    const state = getState()
    rpcCall("SettingsService.savePasswordsPolicy", [getRawSettings(state), true, getCurrentPassword(state), getNewPassword(state)],
        (rpcError) => {
            rpcError.handleOnExceptions([
                Exceptions.INCORRECT_PASSWORD_EXCEPTION,
                Exceptions.PASSWORD_POLICY_VIOLATED_EXCEPTION,
            ])
        })
        .then(data => {
            dispatch(completeReset())
            dispatch(clearPasswords())
            dispatch(setUserPasswordMatchesPolicy(true))
            if (data && data.passwordNotResetFor) {
                dispatch(resetNotCompletedFor(data.passwordNotResetFor))
            }

        })
        .catch((error) => {
            switch (error.getException()) {
                case Exceptions.INCORRECT_PASSWORD_EXCEPTION:
                    dispatch(setCurrentPasswordInvalid(true))
                    break
                case Exceptions.PASSWORD_POLICY_VIOLATED_EXCEPTION:
                    dispatch(setPasswordValidationResult(error.getErrorThrown().passwordValidationResultJson))
                    break
                default:
                    console.error(JSON.stringify(error))
            }
            dispatch(failReset())
        })
}



// WEBPACK FOOTER //
// ./web/js/administration/passwordSettings/actions.js